import { HttpErrorResponse } from '@angular/common/http';

export class ServiceUnavailableError extends Error {
    httpStatus = 503;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, ServiceUnavailableError.prototype);
    }
}
